import { useState } from 'react';

export default function KidsPartyReservationSection() {
  const [formData, setFormData] = useState({
    parentName: '',
    email: '',
    contactNumber: '',
    eventDate: '',
    childAge: '',
    eventType: [],
    extraHour: [],
    additionalRequests: '',
    policies: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;

    // ЧЕКБОКСЫ С МНОЖЕСТВЕННЫМ ВЫБОРОМ
    if (type === "checkbox" && (name === "eventType" || name === "extraHour")) {
      const checked = (e.target as HTMLInputElement).checked;

      setFormData(prev => {
        const list = Array.isArray(prev[name]) ? prev[name] : [];

        if (checked) {
          return { ...prev, [name]: [...list, value] };
        } else {
          return { ...prev, [name]: list.filter(v => v !== value) };
        }
      });

      return;
    }

    // ОДИНОЧНЫЕ ЧЕКБОКСЫ (например policies)
    if (type === "checkbox") {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData(prev => ({ ...prev, [name]: checked }));
      return;
    }

    // ТЕКСТОВЫЕ INPUT/TEXTAREA
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.policies) {
      alert('Please read and accept the policies and reminders');
      return;
    }

    if (formData.additionalRequests.length > 500) {
      alert('Additional requests must be 500 characters or less');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const response = await fetch('/api/event-children', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          parentName: formData.parentName,
          email: formData.email,
          contactNumber: formData.contactNumber,
          eventDate: formData.eventDate,
          childAge: formData.childAge,
          eventType: formData.eventType,
          extraHour: formData.extraHour,
          additionalRequests: formData.additionalRequests.slice(0, 500),
          policies: formData.policies
        })
      });

      if (!response.ok) {
        throw new Error('Request failed');
      }

      setSubmitStatus('success');
      setFormData({
        parentName: '',
        email: '',
        contactNumber: '',
        eventDate: '',
        childAge: '',
        eventType: 'Theme event',
        extraHour: '',
        additionalRequests: '',
        policies: false
      });

    } catch (error) {
      console.error(error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Left Column - Form */}
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Make a Reservation</h2>

            <form onSubmit={handleSubmit} className="bg-white rounded-lg p-4 md:p-8 shadow-lg space-y-6" data-readdy-form
                  id="kids-party-form">
              <div className="grid gap-6">
                <div>
                  <label htmlFor="parentName" className="block text-sm font-medium text-gray-700 mb-2">
                    Name of Parent
                  </label>
                  <input
                      type="text"
                      id="parentName"
                      name="parentName"
                      value={formData.parentName}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address
                  </label>
                  <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                  />
                </div>
              </div>


                <div>
                  <label htmlFor="contactNumber" className="block text-sm font-medium text-gray-700 mb-2">
                    Contact Number
                  </label>
                  <input
                      type="tel"
                      id="contactNumber"
                      name="contactNumber"
                      value={formData.contactNumber}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                  />
                </div>

                <div>
                  <label htmlFor="eventDate" className="block text-sm font-medium text-gray-700 mb-2">
                    Date of the Event
                  </label>
                  <input
                      type="date"
                      id="eventDate"
                      name="eventDate"
                      value={formData.eventDate}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                  />
                </div>



                <div>
                  <label htmlFor="childAge" className="block text-sm font-medium text-gray-700 mb-2">
                    Age of child(ren)
                  </label>
                  <input
                      type="text"
                      id="childAge"
                      name="childAge"
                      value={formData.childAge}
                      onChange={handleInputChange}
                      placeholder="e.g. 5-7 years old"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Type of event:
                  </label>
                  <div className="flex space-x-4">
                    <label className="flex items-center">
                      <input
                          type="checkbox"
                          name="eventType"
                          value="Theme event"
                          checked={formData.eventType.includes('Theme event')}
                          onChange={handleInputChange}
                          className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                      />
                      <span className="text-sm">Theme event</span>
                    </label>

                    <label className="flex items-center">
                      <input
                          type="checkbox"
                          name="eventType"
                          value="Dance/Fitness"
                          checked={formData.eventType.includes('Dance/Fitness')}
                          onChange={handleInputChange}
                          className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                      />
                      <span className="text-sm">Dance/Fitness</span>
                    </label>

                    <label className="flex items-center">
                      <input
                          type="checkbox"
                          name="eventType"
                          value="Yoga"
                          checked={formData.eventType.includes('Yoga')}
                          onChange={handleInputChange}
                          className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                      />
                      <span className="text-sm">Yoga</span>
                    </label>
                  </div>
                </div>


              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Extra:
                </label>
                <div className="flex space-x-6">
                  <label className="flex items-center">
                    <input
                        type="checkbox"
                        name="extraHour"
                        value="1 extra hour of celebration"
                        checked={formData.extraHour.includes('1 extra hour of celebration')}
                        onChange={handleInputChange}
                        className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                    />
                    <span className="text-sm">1 extra hour of celebration</span>
                  </label>

                  <label className="flex items-center">
                    <input
                        type="checkbox"
                        name="extraHour"
                        value="Animator"
                        checked={formData.extraHour.includes('Animator')}
                        onChange={handleInputChange}
                        className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                    />
                    <span className="text-sm">Animator</span>
                  </label>
                </div>
              </div>


              <div>
                <label htmlFor="additionalRequests" className="block text-sm font-medium text-gray-700 mb-2">
                  Any additional requests:
                </label>
                <textarea
                    id="additionalRequests"
                    name="additionalRequests"
                    value={formData.additionalRequests}
                    onChange={handleInputChange}
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm resize-none"
                    placeholder="Please share any special requests or requirements..."
                />
                <p className="text-xs text-gray-500 mt-1">{formData.additionalRequests.length}/500 characters</p>
              </div>

              <div className="flex items-start space-x-3">
                <input
                    type="checkbox"
                    id="policies"
                    name="policies"
                    checked={formData.policies}
                    onChange={handleInputChange}
                    required
                    className="mt-1 text-[#00889D] focus:ring-[#00889D] rounded"
                />
                <label htmlFor="policies" className="text-sm text-gray-700">
                  I have read the policies and reminders
                </label>
              </div>

              {submitStatus === 'success' && (
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                    <p className="text-green-800 text-sm">Thank you! Your reservation request has been submitted
                      successfully. We'll contact you soon to confirm the details.</p>
                  </div>
              )}

              {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <p className="text-red-800 text-sm">Sorry, there was an error submitting your request. Please try
                      again or contact us directly.</p>
                  </div>
              )}

              <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#00889D] text-white py-3 px-6 rounded-lg font-medium hover:bg-[#0F9A8A] transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </div>

          {/* Right Column - Policies */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Please read our policies:</h3>

            <div className="space-y-4 text-sm text-gray-700">
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p><strong>Waivers required:</strong> All guests must sign a waiver prior to or upon arrival.</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p><strong>Shoes-off facility:</strong> Our facility is shoes-off for all adults and children. We kindly
                  ask you and your guests to leave your shoes at shoes cubbies in the reception zone. Please follow this
                  policy to help maintain a clean environment.</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p><strong>All food and beverages must be consumed at the tables only</strong></p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p><strong>No glass or fragile tableware</strong></p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p><strong>Clean-up:</strong> must be done by the end of your reservation</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p><strong>Garbage & Recycling:</strong> All garbage and recycling must be placed in the designated bins provided</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p><strong>We provide small tables, and guests are seated on floor pillows.</strong></p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p><strong>At least 1 chaperone for every 5 children (doesn't count as a guest in max capacity!) is recommended.</strong></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}